import React, { useState } from "react";
import { updatePackageStatus } from "../lib/packages";
import { Modal, toast } from "./UI";

export default function EditStatusModal({ pkg, onClose, onSaved }) {
  const [status, setStatus] = useState(pkg.status);
  const [eta,    setEta]    = useState(pkg.eta || "");
  const [notes,  setNotes]  = useState(pkg.notes || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await updatePackageStatus(pkg.id, status, eta, notes);
      toast("Status updated!");
      onSaved();
      onClose();
    } catch (e) {
      toast(e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Update package status" onClose={onClose} maxWidth={400}>
      <div className="form-row">
        <label>Status</label>
        <select value={status} onChange={e => setStatus(e.target.value)}>
          <option value="Received">Received</option>
          <option value="Shipped">In Transit</option>
          <option value="Delivered">Delivered</option>
        </select>
      </div>
      <div className="form-row">
        <label>Estimated delivery date</label>
        <input type="date" value={eta} onChange={e => setEta(e.target.value)} />
      </div>
      <div className="form-row">
        <label>Warehouse notes</label>
        <textarea rows={2} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Update notes for customer…" />
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? "Saving…" : "Update"}
        </button>
      </div>
    </Modal>
  );
}
